<template>
  <div class="modal is-active">
    <div @click="close()" class="modal-background"></div>
    <form class="modal-card" @submit.prevent="createInvite()">
      <header class="modal-card-head">
        <p class="modal-card-title d-flex align-items-center">
          <span class="mr-2 mt-2 mb-2">Invite a user</span>
        </p>
        <button type='button' @click="close()" class="delete"></button>
      </header>
      <section class="modal-card-body">

        <input
            type="email"
            class="title input"
            :class="error && 'is-danger'"
            v-model="userEmail"
            placeholder="j.potter@website.com"
            />
      </section>
      <footer class="modal-card-foot">
        <button
            type='submit'
            class='button is-primary'
            :class="loading && 'is-loading'">
            Send Invite
          </button>
      </footer>
    </form>
  </div>
</template>

<script>
import store from '../store.js'

export default {
  name: 'InviteModal',
  data () {
    return {
      userEmail: '',
      loading: false,
      error: false,
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async createInvite () {
      this.loading = true
      this.error = false
      try {
        await store.dispatch('createInvite', { email: this.userEmail })
        this.userEmail = ''
        this.close()
      } catch (err) {
        this.error = true
      }
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}

.error-container {
  border-radius: 5px;
  padding: 5px;
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
}
</style>



// WEBPACK FOOTER //
// InviteModal.vue?9813951a